import React from 'react';
import {
	getPrecisePriceWithCurrency,
	getPriceWithDisplayCurrencyByPrecision,
} from 'arbitrip-common/general/utils/Currencies';
import { useTranslation } from 'react-i18next';
import { getPriceValue } from '../utils';

const PaymentSummary = ({ profile, booking, chargeCurrency }) => {
	const { t } = useTranslation();

	const currency = booking?.deal?.cheapopoPricing?.currency;
	const total_net_price = booking?.deal?.cheapopoPricing?.purchase_price;
	const total_client_price = booking.deal?.cheapopoPricing?.cheapopoTotalPrice;
	const total_commission =
		booking?.deal?.cheapopoPricing?.agentPricing?.absolute_margin_total ||
		booking?.deal?.cheapopoPricing?.commissionTotal ||
		0;

	const total_to_pay = total_net_price + total_commission || total_client_price;
	const additional_currency = chargeCurrency && chargeCurrency !== currency;

	return (
		<div className="payment-method__summary">
			<div className="payment-method__title">{t('TotalToPay')}</div>
			<div className="payment-method__sum">
				{additional_currency ? (
					<React.Fragment>
						<span className="approx">{t('Bookings.SettlePayment.Approx')}</span>
						{getPriceWithDisplayCurrencyByPrecision(
							total_to_pay,
							profile.freelance_agent_pay_later_exchange_rates[chargeCurrency],
							chargeCurrency,
							2,
						)}
					</React.Fragment>
				) : (
					getPrecisePriceWithCurrency(total_to_pay, currency)
				)}
			</div>
			{!!total_commission && <div className="payment-method__commission">
				{t('Commission')} {getPriceValue(total_commission, currency, chargeCurrency, profile)}
			</div>}
		</div>
	);
};

export default PaymentSummary;
